import { createFileRoute, redirect } from '@tanstack/react-router';

/* Prep-digest cards already sent in Teams still link here; their overview is the agenda. */
export const Route = createFileRoute('/_app/meetings/')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true });
  },
});
